import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

import { CustomSelectComponent } from '../../../shared/custom-select/custom-select.component';
import { CustomButtonComponent } from '../../../shared/custom-button/custom-button.component';


@Component({
  selector: 'app-select-warehouse',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatIconModule,
    MatButtonModule,
    CustomSelectComponent,
    CustomButtonComponent
  ],
  templateUrl: './select-warehouse.component.html',
  styleUrl: './select-warehouse.component.scss',
})
export class SelectWarehouseComponent implements OnInit {
  ELEMENT_IDS: { [key: string]: string } = ELEMENT_IDS;
  @Input() warehouseList: any[] = [];
  @Output() onSubmitEmitter: EventEmitter<{}> = new EventEmitter();

  formGroup: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder
  ) {
    this.formGroup = this.fb.group({
        warehouse: [null, Validators.required]
    });
  }

  ngOnInit(): void {}

  onSubmit() {
    if (this.formGroup.valid) {
        this.loading = true;
        this.onSubmitEmitter.emit(this.formGroup.value.warehouse);
    }
  }
}

const BASE_ELEMENT_ID: string = 'id_select_warehouse';
const ELEMENT_IDS: { [key: string]: string } = {
  page: `${BASE_ELEMENT_ID}_page`,
  hdr: `${BASE_ELEMENT_ID}_hdr`,
  lbl_title: `${BASE_ELEMENT_ID}_lbl_title`,
  lbl_subtitle: `${BASE_ELEMENT_ID}_lbl_subtitle`,
  form: `${BASE_ELEMENT_ID}_form`,
  dropdown_warehouse: `${BASE_ELEMENT_ID}_dropdown_warehouse`,
  btn_proceed: `${BASE_ELEMENT_ID}_btn_proceed`,
};
